import { createContext, useContext } from "react";

export const SchoolCtx = createContext(null);
export const useSchool = () => useContext(SchoolCtx);
